import useAct from '../useAct'
import CloseModal from './CloseModal.jsx'
import './PageContainer.scoped.scss'

const total = 100 // Total number of submissions - hardcoded for now

function percentage(partialValue, totalValue) {
    if (partialValue === 0 || totalValue === 0) {
        return 0
    }
    return Math.round((100 * partialValue) / totalValue)
}

function FlowHeader({ }) {
    const act = useAct()
    const { id, stats, status, slug } = useSel((s) => s.flow)
    const [showCloseModal, setShowCloseModal] = useState(false)

    const closeFlow = (redirectUrl) => {
        act.flow.close(id, redirectUrl)
        setShowCloseModal(false)
    }

    const reopenFlow = () => {
        act.flow.reopen(id)
    }

    return <div className='box gap' id='status'>
        <div className="poster-container">
            <div className="poster">
                {slug ? (
                    <iframe
                        src={`/target/flows/${slug}`}
                        title="Embedded Page"
                        className="iframe"
                        loading="lazy"
                    ></iframe>
                ) : (
                    <SvgCircLoading />
                )}
            </div>
        </div>
        <div className='main'>
            <div className='header row'>
                <h1 className='no-margin-top'>Page {status === 'closed' ? 'Closed' : status ? 'Active' : ''}</h1>
                <div className='actions'>
                    {status !== 'closed' &&
                        <button className="button red primary" onClick={() => setShowCloseModal(true)}>
                            Close
                        </button>
                    }
                    {status === 'closed' &&
                        <button className="button green primary" onClick={reopenFlow}>
                            Re-open
                        </button>
                    }
                    <CloseModal
                        hide={() => setShowCloseModal(false)}
                        onSubmit={closeFlow}
                        open={showCloseModal}
                    />
                </div>
            </div>
            <div className={`progress-bar margin-top double ${status === 'paused' ? 'paused' : ''}`}>
                {(stats?.flowsCompleted || 0) < total && <>
                    <div className="progress-bar-bar-container">
                        <div className="bar" style={{ width: `${percentage((stats?.flowsCompleted || 0), total)}%` }}></div>
                    </div>
                    <div className="progress-bar-info margin-top">
                        <div className="progress-bar-info-block --left">{(stats?.flowsCompleted || 0).toLocaleString()} out of {total.toLocaleString()} submissions received</div>
                        <div className="progress-bar-info-block --right">{percentage((stats?.flowsCompleted || 0), total)}%</div>
                    </div>
                </>}
            </div>
        </div>
    </div>
}

export default FlowHeader
